import React from 'react'

import { withNamespaces } from "react-i18next";

class LayerInfo extends React.Component {
  render() {
    const { t, layer } = this.props;

    return (
      <div>{ layer.descCode ? t(layer.descCode) : layer.desc}</div>
    );
  }
}

export default withNamespaces()(LayerInfo);